import InfoPanel from './panel/InfoPanel'
import PrimaryLink from './buttons/PrimaryLink'
import clsx from 'clsx'
import { compose } from 'ramda'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  dismissPlaceMessage,
  dismissPlaceAllMessages,
} from '../../app/store/actions/place.actions'
import { useDispatch } from 'react-redux'
import effects from 'app/effects/effects'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  cancelLink: {
    padding: '6px 0',
    fontWeight: 'bold',
    marginTop: '1px',
    color: '#0073b1',
  },
  dismiss: {
    flex: '0 1 auto',
  },
  messagesCount: {
    marginTop: 7,
  },
  actions: {
    '@media (max-width: 440px)': {
      alignSelf: 'end',
    },
  },
  titleCountContainer: {
    display: 'flex',
    width: '89%',
    '@media (max-width: 780px)': {
      width: '100%',
    },
  },
  titleContentContainer: {
    alignItems: 'center',
    flexDirection: 'column',
    '@media (max-width: 440px)': {
      marginRight: '0.75rem',
    },
  },
  contentContainer: {
    '@media (max-width: 440px)': {
      flexDirection: 'column',
      '&>div:first-child': {
        width: '100%',
        alignItems: 'baseline',
      },
    },
  },
}))

export default ({
  content: { id, body, title = '' },
  placeId,
  messagesTotalCount,
  dismissedMessagesCount,
}) => {
  const dismiss = (currentId) => {
    effects.apis
      .messageDismiss({ id })
      .then(() => compose(dispatch, dismissPlaceMessage)(currentId))
  }
  const contentBody = body.replaceAll(/<a /g, '<a target=_blank ')
  const dismissAll = () => {
    effects.apis
      .allMessagesDismiss({ placeId })
      .then(() => compose(dispatch, dismissPlaceAllMessages)(placeId))
  }
  const classes = useStyles()

  const dispatch = useDispatch()

  return (
    <div>
      <InfoPanel>
        <div
          className={clsx(
            `flex justify-between items-center`,
            classes.contentContainer,
          )}
        >
          <div
            className={clsx(
              classes.titleContentContainer,
              'flex-1 px-5 max-h-136 overflow-y-auto',
            )}
          >
            <div className="font-bold pb-4">{title}</div>
            <div dangerouslySetInnerHTML={{ __html: contentBody }} />
          </div>

          <div className={clsx(classes.dismiss, classes.actions)}>
            <div className="pb-4">
              <PrimaryLink
                onClick={() => dismissAll()}
                className={clsx(classes.cancelLink, 'underline font-bold')}
                style={{ minWidth: '65px' }}
              >
                <FormattedMessage id="message.clear_all" />
              </PrimaryLink>
            </div>
            <div>
              <PrimaryLink
                onClick={() => dismiss(id)}
                className={clsx(classes.cancelLink, 'underline font-bold')}
              >
                <FormattedMessage id="message.clear" />
              </PrimaryLink>
              <span className={clsx(classes.cancelLink, 'px-2')}>
                ({dismissedMessagesCount}/{messagesTotalCount})
              </span>
            </div>
          </div>
        </div>
      </InfoPanel>
    </div>
  )
}
